<template>
    <div class="col-lg-12">
        <div class="card stretch stretch-full">
            <div class="card-header">
                <h5 class="card-title">Hayvan Listesi</h5>
                <div class="card-header-action">
                    <div class="card-header-btn">
                        <div data-bs-toggle="tooltip" title="Yenile">
                            <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                data-bs-toggle="refresh"> </button>
                        </div>
                        <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                            <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                data-bs-toggle="expand"> </a>
                        </div>
                    </div>
                    <div class="dropdown">
                        <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                            data-bs-offset="25, 25">
                            <div data-bs-toggle="tooltip" title="Seçenekler">
                                <i class="feather-more-vertical"></i>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <router-link to="/animal/add" class="dropdown-item"><i class="feather-plus-circle"></i>Yeni
                                Ekle</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body custom-card-action p-0">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Kimlik No</th>
                                <th scope="col">Türü</th>
                                <th scope="col">Davranış Şekli</th>
                                <th scope="col">Geldiği Yer</th>
                                <th scope="col">Geldiği Tarih</th>
                                <th scope="col" class="text-end">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="animal in animals" :key="animal.id">
                                <td>
                                    <div class="hstack gap-3">
                                        <div class="avatar-text bg-soft-primary text-primary">
                                            <i class="feather-book-open"></i>
                                        </div>
                                        <div>
                                            <router-link :to="{ name: 'AnimalDetail', params: { id: animal.id } }"
                                                class="d-block mb-1">{{ animal.id_number }}</router-link>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <a class="d-block mb-1">{{ animal.species_name }}</a>
                                        <div class="d-flex gap-3">
                                            <a class="hstack gap-1 fs-11 fw-normal text-muted">
                                                <span>Cinsi: {{ animal.breed_name }}</span>
                                            </a>
                                            <a class="hstack gap-1 fs-11 fw-normal text-muted">
                                                <span>Yaşı: {{ animal.age }}</span>
                                            </a>
                                            <a class="hstack gap-1 fs-11 fw-normal text-muted">
                                                <span>Cinsiyeti: {{ animal.gender }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                                <td>{{ animal.behavior_pattern }}</td>
                                <td>{{ animal.owner_address }}</td>
                                <td class="fw-bold">{{ formatDate(animal.arrival_date) }}</td>
                                <td>
                                    <div class="hstack gap-2 justify-content-end">
                                        <router-link :to="{ name: 'AnimalDetail', params: { id: animal.id } }"
                                            class="avatar-text avatar-md bg-orange">
                                            <i class="feather-eye fs-16"></i>
                                        </router-link>
                                        <a href="#" @click="handleDelete(animal.id)"
                                            class="avatar-text avatar-md bg-red">
                                            <i class="feather-delete fs-16"></i>
                                        </a>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer">
                <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                    @page-changed="fetchData" />
            </div>
        </div>
    </div>
    <Topbar @search="handleTopbarSearch" />
</template>

<script>
import { deleteAnimal } from '@/services/apiService';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';


export default {
    name: 'AnimalsTable',
    components: {
        Pagination,
    },
    data() {
        return {
            animals: [],
            currentPage: 1,
            totalPages: 1,
            next: true,
            previous: false,
            searchValue: '',
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    computed: {

    },
    methods: {
        handleTopbarSearch(keyword) {
            this.searchValue = keyword;
            this.fetchData();
        },
        async fetchData(page = 1) {
            console.log('fetch data called');
            try {
                const response = await this.$axios.get(`animal/?page=${page}&search=${this.searchValue}`);
                console.log('response:', response.data.results);
                this.animals = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        handleDelete(id) {
            deleteAnimal(id, (deletedId) => {
                this.animals = this.animals.filter(animal => animal.id !== deletedId);
            });
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>